import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { of, tap } from 'rxjs';

type CacheUrl = string;

interface CacheEntry {
  response: HttpResponse<unknown>;
  timestamp: number;
}

const cache = new Map<CacheUrl, CacheEntry>();
const CACHE_DURATION = 10 * 60 * 1000; // 10 минут в миллисекундах
const MAX_CACHE_SIZE = 50;

const isCacheValid = (entry: CacheEntry, now: number): boolean =>
  now - entry.timestamp < CACHE_DURATION;

export const cacheInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method !== 'GET') return next(req);

  const cachedEntry = cache.get(req.urlWithParams);
  const now = Date.now();

  if (cachedEntry && isCacheValid(cachedEntry, now))
    return of(cachedEntry.response.clone());

  return next(req).pipe(
    tap((response) => {
      if (response instanceof HttpResponse && response.ok) {
        if (cache.size >= MAX_CACHE_SIZE) {
          const firstKey = cache.keys().next().value;
          if (firstKey) cache.delete(firstKey);
        }

        cache.set(req.urlWithParams, {
          response: response.clone(),
          timestamp: now,
        });
      }
    }),
  );
};
